/**
 * Created by chachora on 12/19/18.
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';
import { positiveInteger, positiveNumber } from '../Form/validators';
import styles from '../EventDialogForm/styles';
import * as eh from '../../helpers/event-helper';
import { withTranslation } from 'react-i18next';

import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  GridButton,
  GridIconFab,
  GridDateTimePicker,
  GridNumberField,
  GridTextField,
  Placeholder,
  TextField,
} from '../Form/shared';
import { FormBlock, FormTextField, FormNumberField, FormSelect } from '../Form';
import Transfers from '../EventDialogForm/Transfers';
import PanelSummary from '../PanelSummary';
import { dateToTimeString } from '../../helpers/dates';
import Ramp from '../EventDialogForm/Ramp';
import Tasks from '../EventDialogForm/Tasks/Tasks';
import withDeletePopup from '../withDeletePopup';

export const initialCargoValue = {
  awbNumber: null,
  packages: null,
  weight: null,
};

export const totalTransferPaxLoad = (transfers, paxClass) =>
  eh.calcObjectTotal({
    outbound: eh.calcObjectTotal(
      transfers.outbound.reduce(
        (total, value, i) => ({ ...total, [i]: value[paxClass] }),
        {}
      )
    ),
    transit: eh.calcObjectTotal(
      transfers.transit.reduce(
        (total, value, i) => ({ ...total, [i]: value[paxClass] }),
        {}
      )
    ),
  });

export const totalTransfers = (transfers, transferType) =>
  transfers[transferType].reduce((total, value) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { STA, STD, ...filteredValue } = value;
    return total + eh.calcObjectTotal(filteredValue);
  }, null);

class EventInboundForm extends Component {
  state = {
    expandedCargoItem: null,
  };

  handleAddCargoClick = () => {
    const { setFieldValue, values } = this.props;
    setFieldValue(
      `inbound.cargo[${values.inbound.cargo.length}]`,
      initialCargoValue
    );
  };

  handleDeleteCargoClick = index => {
    const { setFieldValue, values } = this.props;
    setFieldValue('inbound.cargo', [
      ...values.inbound.cargo.slice(0, index),
      ...values.inbound.cargo.slice(index + 1),
    ]);
  };

  handleExpandedCargoItem = index => {
    const { expandedCargoItem } = this.state;
    this.setState({
      expandedCargoItem: index === expandedCargoItem ? null : index,
    });
  };

  render() {
    const {
      classes,
      values,
      initialValues,
      setFieldValue,
      rampServices,
      onDeleteConfirmationDialogOpen,
      t,
    } = this.props;
    const { expandedCargoItem } = this.state;
    const { inbound } = values;
    const { transfers } = inbound;
    const [isDelayed, dlTimeValue] = eh.calculateDelayTime(
      values.STA,
      inbound.ATA ? inbound.ATA : inbound.ETA
    );

    const paxLoad = inbound.paxLoad ? inbound.paxLoad : {};
    let totalPaxLoad = eh.getTotalCrewCount(paxLoad);
    if (!totalPaxLoad) totalPaxLoad = '';

    const aircraftSummaryItems = [
      { label: 'Type', value: inbound.aircraftType },
      { label: 'REG', value: inbound.aircraftReg },
      {
        label: 'Crew',
        value: eh.getTotalCrewCount(inbound.crew),
      },
    ];

    const movementSummaryItems = [
      { label: 'ETA', value: dateToTimeString(inbound.ETA) },
      { label: 'ATA', value: dateToTimeString(inbound.ATA) },
      { label: 'DL Time', value: dlTimeValue },
    ];

    const parkingBaySummaryItems = [
      { label: 'Parking no.', value: inbound.parkingBay },
    ];

    const paxLoadSummaryItems = [
      { label: 'F', value: paxLoad.first },
      { label: 'C', value: paxLoad.business },
      { label: 'Y', value: paxLoad.economy },
      { label: 'INF', value: paxLoad.infant },
      { label: 'Total', value: totalPaxLoad },
      { label: 'Outbound', value: paxLoad.onwardConnection },
      { label: 'Transit', value: paxLoad.transit },
    ];

    const transferSummaryItems = [
      {
        label: 'F',
        value: totalTransferPaxLoad(transfers, 'first'),
      },
      {
        label: 'C',
        value: totalTransferPaxLoad(transfers, 'business'),
      },
      {
        label: 'Y',
        value: totalTransferPaxLoad(transfers, 'economy'),
      },
      {
        label: 'INF',
        value: totalTransferPaxLoad(transfers, 'infant'),
      },
      {
        label: 'Outbound',
        value: totalTransfers(transfers, 'outbound') || null,
      },
      {
        label: 'Transit',
        value: totalTransfers(transfers, 'transit') || null,
      },
    ];

    const cargoSummaryItems = [
      {
        label: 'AWB No.',
        value: inbound.cargo.length === 0 ? null : inbound.cargo.length,
      },
      {
        label: 'PC',
        value: eh.calcArrayPropertyTotal(inbound.cargo, 'packages'),
      },
      {
        label: 'WT',
        value: eh.calcArrayPropertyTotal(inbound.cargo, 'weight'),
      },
    ];

    return (
      <>
        {/*Aircraft*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary
              title={t('Aircraft/Crew')}
              items={aircraftSummaryItems}
            />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock variant="contained">
              <FormTextField
                label={t('Aircraft_type')}
                name="inbound.aircraftType"
              />
              <FormTextField
                label={t('Aircraft_registration')}
                name="inbound.aircraftReg"
              />
            </FormBlock>
            <FormBlock variant="contained">
              <FormNumberField
                label={t('Pilots')}
                name="inbound.crew.pilots"
                positiveInteger
              />
              <FormNumberField
                label={t('Cabin_Crew')}
                name="inbound.crew.cabin"
                positiveInteger
              />
              <FormNumberField
                label={t('DHC')}
                name="inbound.crew.deadhead"
                positiveInteger
              />
              <FormSelect name="crewChangeType" items={eh.CREW_CHANGE_TYPES} />
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/*Movement*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary title={t('Movement')} items={movementSummaryItems} />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              <GridDateTimePicker xs={6} label="ETA" name="inbound.ETA" />
              <GridDateTimePicker xs={6} label="ATA" name="inbound.ATA" />
            </FormBlock>
            <FormBlock>
              <FormTextField
                size={3}
                label={t('DL_Time')}
                value={dlTimeValue}
              />
              {!isDelayed && (
                <>
                  <Placeholder xs={5} />
                  <GridButton xs={3} color="secondary" label="Delayed" />
                </>
              )}
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/*Parking*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary
              title={t('Locations')}
              items={parkingBaySummaryItems}
            />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              <FormSelect
                name="inbound.parkingStand"
                items={eh.PARKING_STAND_TYPES}
              />
              <FormTextField
                label={t('Parking_no.')}
                name="inbound.parkingBay"
              />
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/*Arrival notes and tasks*/}
        <Tasks
          tasksTitle={t('Arrival tasks')}
          notesTitle={t('Arrival notes')}
          tasksName="inbound.tasks"
          tasks={inbound.tasks}
          notes={inbound.notes}
          notesName="inbound.notes"
          setFieldValue={setFieldValue}
        />
        {/*Comments*/}
        {!!initialValues.inbound.comments && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={classNames({
                [classes.warning]: inbound.comments,
              })}
            >
              Arrival Comments and Notes
            </AccordionSummary>
            <AccordionDetails className={classes.expansionDetails}>
              <TextField
                multiline
                rows="4"
                maxRows="16"
                variant="outlined"
                name="inbound.comments"
              />
            </AccordionDetails>
          </Accordion>
        )}
        {/*PAX Load*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary title={t('Pax_load')} items={paxLoadSummaryItems} />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              <FormNumberField
                size={2}
                label="F"
                name="inbound.paxLoad.first"
                allowedInputValue={positiveInteger}
              />
              <FormNumberField
                size={2}
                label="C"
                name="inbound.paxLoad.business"
                allowedInputValue={positiveInteger}
              />
              <FormNumberField
                size={2}
                label="Y"
                name="inbound.paxLoad.economy"
                allowedInputValue={positiveInteger}
              />
              <FormNumberField
                size={2}
                label="INF"
                name="inbound.paxLoad.infant"
                allowedInputValue={positiveInteger}
              />
              <Placeholder xs={2} />
              <FormTextField size={2} label="Total" value={totalPaxLoad} />
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/*Transfer/Transit*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary
              title={t('Transfer_Transit')}
              items={transferSummaryItems}
            />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              {t('Outbound')}
              <Transfers
                values={values}
                setFieldValue={setFieldValue}
                name="inbound.transfers.outbound"
              />
            </FormBlock>
            <FormBlock>
              {t('Transit')}
              <Transfers
                values={values}
                setFieldValue={setFieldValue}
                name="inbound.transfers.transit"
              />
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/*Special Handling*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {t('Special_Handling')}
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <TextField
              multiline
              rows="4"
              variant="outlined"
              name="inbound.specialHandling"
            />
          </AccordionDetails>
        </Accordion>
        {/*Cargo*/}
        {/*TODO: need to merge with main repo: current version doesn't have Notes */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary title={t('Cargo/Mail')} items={cargoSummaryItems} />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              {inbound.cargo.map((cargo, i) => (
                <Accordion
                  expanded={expandedCargoItem === i}
                  key={`inbound.cargo[${i}]`}
                >
                  <AccordionSummary
                    className={classNames(classes.innerExpansionSummary, {
                      [classes.warning]: inbound.cargo[i].comments,
                    })}
                    expandIcon={
                      <ExpandMoreIcon
                        onClick={this.handleExpandedCargoItem.bind(null, i)}
                      />
                    }
                  >
                    <FormBlock key={i}>
                      <GridTextField
                        xs={5}
                        label="AWB No."
                        name={`inbound.cargo[${i}].awbNumber`}
                      />
                      <GridNumberField
                        xs={2}
                        label={t('PC')}
                        name={`inbound.cargo[${i}].packages`}
                        allowedInputValue={positiveInteger}
                      />
                      <GridNumberField
                        xs={2}
                        label={t('WT')}
                        name={`inbound.cargo[${i}].weight`}
                        allowedInputValue={positiveNumber}
                      />
                    </FormBlock>
                  </AccordionSummary>
                  <AccordionDetails className={classes.expansionDetails}>
                    <TextField
                      multiline
                      fullWidth
                      label={t('Notes')}
                      rows="4"
                      maxRows="5"
                      variant="outlined"
                      name={`inbound.cargo[${i}].comments`}
                    />
                    <FormBlock>
                      <Placeholder xs={9} />
                      <GridIconFab
                        className={classes.withTopSpacer}
                        color="secondary"
                        xs={3}
                        icon="delete"
                        onClick={() =>
                          onDeleteConfirmationDialogOpen(
                            this.handleDeleteCargoClick.bind(null, i)
                          )
                        }
                      />
                    </FormBlock>
                  </AccordionDetails>
                </Accordion>
              ))}
            </FormBlock>
            <FormBlock>
              <Placeholder xs={9} />
              <GridButton
                xs={3}
                variant="contained"
                color="primary"
                label={t('ADD')}
                onClick={this.handleAddCargoClick}
              />
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/*Ramp*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {t('Ramp')}
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <Ramp
              values={values}
              setFieldValue={setFieldValue}
              services={rampServices}
            />
          </AccordionDetails>
        </Accordion>
        {/*Dubai pax billing*/}
        {false && (
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              Dubai pax billing
            </AccordionSummary>
            <AccordionDetails className={classes.expansionDetails}>
              <FormBlock>
                <FormNumberField
                  label="Arriving"
                  name="inbound.airportTaxes.arriving"
                  allowedInputValue={positiveInteger}
                  variant="inline"
                />
                <FormNumberField
                  label="Transfers <12h"
                  name="inbound.airportTaxes.transfersLess12h"
                  allowedInputValue={positiveInteger}
                  variant="inline"
                />
                <FormNumberField
                  label="Transfers >12h and <24h"
                  name="inbound.airportTaxes.transfersBetween12hAnd24h"
                  allowedInputValue={positiveInteger}
                  variant="inline"
                />
                <FormNumberField
                  label="Transfers >24h"
                  name="inbound.airportTaxes.transfersMore24h"
                  allowedInputValue={positiveInteger}
                  variant="inline"
                />
                <FormNumberField
                  label="Transit with the same flight number"
                  name="inbound.airportTaxes.transitSameFlight"
                  allowedInputValue={positiveInteger}
                  variant="inline"
                />
              </FormBlock>
            </AccordionDetails>
          </Accordion>
        )}
        {/*Additional*/}
        {/*<Accordion>*/}
        {/*  <AccordionSummary expandIcon={<ExpandMoreIcon />}>*/}
        {/*    Additional*/}
        {/*  </AccordionSummary>*/}
        {/*  <AccordionDetails className={classes.expansionDetails}>*/}
        {/*    <GridContainer>*/}
        {/*      <Grid item xs={6}>*/}
        {/*        <FormControlLabel*/}
        {/*          control={<Switch color="primary" name="inbound.MEL" />}*/}
        {/*          label="MEL"*/}
        {/*        />*/}
        {/*      </Grid>*/}
        {/*      <Grid item xs={6}>*/}
        {/*        <Button variant="outlined">Send Request</Button>*/}
        {/*      </Grid>*/}
        {/*    </GridContainer>*/}
        {/*  </AccordionDetails>*/}
        {/*</Accordion>*/}
      </>
    );
  }
}

export default withTranslation()(
  withStyles(styles)(withDeletePopup(EventInboundForm))
);
